module.exports = __webpack_public_path__ + "img/kaohe_bg.21903cb9.png";